import React from "react";

const PageHeader = ({ title, subtitle, image }) => {
  return (
    <div className="relative h-[40vh] md:h-[50vh] flex items-center justify-center overflow-hidden bg-dreibach-black">
      <div className="absolute inset-0 z-0">
        <img 
          src={image || "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=2000"} 
          alt={title}
          className="w-full h-full object-cover opacity-30 grayscale"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-dreibach-black to-transparent" />
      </div>
      
      <div className="container relative z-10 px-6 text-center mt-20">
        <h1 className="heading-lg text-white mb-4 animate-fade-in-up">{title}</h1>
        {subtitle && (
          <p className="text-xl md:text-2xl text-gray-400 font-light max-w-3xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
